const $searchBySel = $('#searchBy');

$searchBySel.selectize();

$searchBySel.change((e) => {
    const url = e.target.value;

    window.location = url;
});